import { render, staticRenderFns } from "./Select2.vue?vue&type=template&id=b8eda9a6&"
import script from "./Select2.vue?vue&type=script&lang=js&"
export * from "./Select2.vue?vue&type=script&lang=js&"
import style0 from "./Select2.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Ampps\\www\\strana\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b8eda9a6')) {
      api.createRecord('b8eda9a6', component.options)
    } else {
      api.reload('b8eda9a6', component.options)
    }
    module.hot.accept("./Select2.vue?vue&type=template&id=b8eda9a6&", function () {
      api.rerender('b8eda9a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/resources/js/components/Select2.vue"
export default component.exports